import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as documentUpload from '../document-upload'

/** Browser and upload workspace for Tenant- and Zone-targeted documents. */
@ngCore.Component({
  imports: [
    ds.input.select.single.Component,
    ds.layout.widget.Component,
    ds.table.Component,
    documentUpload.Component,
  ],
  selector: 'atn-admin-knowledge-bases-page-shared-tab',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Target values used by the Shared document audience selector. */
  public readonly targetTypes = ents.core.agent.KnowledgeBase.Target.Type

  /** Tenant and Zone audience choices supported by read-only Shared browsing. */
  public readonly targetTypeItems: readonly ds.input.select.models.Item<
    | ents.core.agent.KnowledgeBase.Target.Type.Tenant
    | ents.core.agent.KnowledgeBase.Target.Type.Zone
  >[] = [
    {
      label: 'Tenant',
      value: ents.core.agent.KnowledgeBase.Target.Type.Tenant,
    },
    {
      label: 'Zone',
      value: ents.core.agent.KnowledgeBase.Target.Type.Zone,
    },
  ]

  /** Route-bound collection shared with the page and Agent tab. */
  public readonly filesEc = ngCore.inject(
    state.admin.agentKnowledgeBases.Collection,
  )

  /** Canonical embedded table input for shared documents. */
  public readonly documentsTableConfig = {
    collection: this.filesEc,
    view: {
      container: 'embedded' as const,
      pagination: true,
      showColumnSettings: false,
      title: 'Shared documents',
    },
  } satisfies ds.table.ec.Config.Input<state.admin.agentKnowledgeBases.TypeParams>

  /** Converts tenants into audience selector options. */
  public getTenantItems(
    tenants: readonly ents.core.admin.Tenant[],
  ): readonly ds.input.select.models.Item<ents.core.admin.Tenant.Id>[] {
    return tenants.map(tenant => ({
      label: tenant.name,
      value: tenant.id,
    }))
  }

  /** Converts zones into audience selector options. */
  public getZoneItems(
    zones: readonly ents.core.admin.Zone[],
  ): readonly ds.input.select.models.Item<ents.core.admin.Zone.Id>[] {
    return zones.map(zone => ({
      label: zone.name,
      value: zone.id,
    }))
  }
}
